<template>
    <sub>{{ this.$slots.default[0].text }}</sub>
</template>
<script>
export default {
    name: 'EmbedSuperscript'
}
</script>
